import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '../../../models/adapters/EnableGuestWebResultAdapter';
import EnableGuestWebResult from '../../../models/interfaces/EnableGuestWebResult';
import { enableGuestWeb, EnableGuestWebActionType, enableGuestWebFailed, enableGuestWebFinished } from '../../actions/place/enableGuestWeb';
import getPublicResponse from '../getPublicResponse';

function* enableGuestWebSaga({ payload }: EnableGuestWebActionType) {
  const timestamp = moment();
  const { token, enable } = payload;
  const response = yield getPublicResponse(PublicServerPlaceEvent.enableGuestWeb, {
    token,
    enable,
  });
  const { enableGuestWebResult, error } = response;
  if (error) {
    const action = enableGuestWebFailed({
      token,
      enableGuestWebResult: EnableGuestWebResult.failed,
      timestamp,
    });
    yield put(action);
  } else {
    const action = enableGuestWebFinished({
      token,
      enableGuestWebResult: fromDto(enableGuestWebResult),
      timestamp,
    });
    yield put(action);
  }
}

export default function* watchEnableGuestWebSaga() {
  yield takeEvery(enableGuestWeb, enableGuestWebSaga);
}
